import { Button } from "@/components/ui/button";
import { Truck, LogOut, RefreshCw, MessageSquare, Bell, KeyRound, Trophy } from "lucide-react";
import { toast } from "sonner";
import { ensurePushSubscription } from "@/lib/push";

/**
 * Header sticky do MobileEntregador. Isolado para desafogar a página principal.
 * Props: userNome, unreadCount, totalUnread, onOpenAllUnread, onReload, loading, onLogout, onChangePassword, onOpenDesempenho
 */
export function MobileHeader({ userNome, unreadCount, totalUnread, onOpenAllUnread, onReload, loading, onLogout, onChangePassword, onOpenDesempenho }) {
  const activateNotif = async () => {
    const r = await ensurePushSubscription();
    if (r?.ok) toast.success("Notificações ativadas");
    else if (r?.reason === "denied") toast.error("Permita notificações nas configurações");
    else if (r?.reason === "unsupported") toast.error("Navegador sem suporte");
    else toast.error("Não foi possível ativar");
  };
  return (
    <header className="bg-orange-600 text-white p-4 sticky top-0 z-10 shadow-md" data-testid="mobile-header">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Truck className="w-6 h-6" />
          <div>
            <div className="font-extrabold text-lg leading-tight">{userNome}</div>
            <div className="text-[10px] opacity-80 uppercase">Entregador</div>
          </div>
        </div>
        <div className="flex gap-1 items-center">
          {unreadCount > 0 && (
            <div className="relative animate-pulse bg-red-600 text-white rounded-full px-2 h-8 flex items-center gap-1 shadow-lg mr-1"
              data-testid="mobile-global-unread"
              onClick={onOpenAllUnread}
              role="button" title="Ver todas as entregas com mensagens não lidas">
              <MessageSquare className="w-4 h-4 animate-bounce" />
              <span className="text-xs font-extrabold">{totalUnread}</span>
            </div>
          )}
          <Button size="icon" variant="ghost" className="text-white hover:bg-orange-500" data-testid="mobile-btn-notif" onClick={activateNotif}>
            <Bell className="w-5 h-5" />
          </Button>
          {onOpenDesempenho && (
            <Button size="icon" variant="ghost" className="text-white hover:bg-orange-500" onClick={onOpenDesempenho} data-testid="mobile-btn-desempenho" title="Meu desempenho">
              <Trophy className="w-5 h-5" />
            </Button>
          )}
          <Button size="icon" variant="ghost" className="text-white hover:bg-orange-500" onClick={onReload}>
            <RefreshCw className={`w-5 h-5 ${loading ? "animate-spin" : ""}`} />
          </Button>
          {onChangePassword && (
            <Button size="icon" variant="ghost" className="text-white hover:bg-orange-500" onClick={onChangePassword} data-testid="mobile-btn-change-password" title="Alterar minha senha">
              <KeyRound className="w-5 h-5" />
            </Button>
          )}
          <Button size="icon" variant="ghost" className="text-white hover:bg-orange-500" onClick={onLogout} data-testid="mobile-logout">
            <LogOut className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </header>
  );
}
